import { observer } from 'mobx-react-lite'
import React, { useRef } from 'react'
import { Image, StyleSheet, TouchableOpacity } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { WebView } from 'react-native-webview'

import { useStore } from '../../models'
import { DS } from '../../design-system'
import { useLocalSearchParams, useRouter } from 'expo-router'
// TODO: DEPRECATE
export const WebViewScreen = observer(() => {
  const router = useRouter()
  const insets = useSafeAreaInsets()
  const webview = useRef(null)
  const store = useStore()
  const params = useLocalSearchParams<{ url: string }>()
  const visitingUrl = params?.url ? params.url : ''

  const goToHome = () => {
    if (store.communication.channel?.channelName) {
      // navigation.navigate(DrawerRoutes.game)
      router.navigate('/game')
    } else if (router.canGoBack()) {
      router.back()
      return
    }
    router.navigate('/(root)/(tabs)')
  }

  return (
    <SafeAreaView style={styles.webview}>
      <TouchableOpacity
        onPress={goToHome}
        style={[
          styles.headerBackButtonContainer,
          {
            top: insets.top + 18
          }
        ]}
      >
        <Image source={require('../../../assets/menu/left-arrow.png')} style={[styles.headerBackButton]} />
      </TouchableOpacity>
      <WebView ref={webview} source={{ uri: visitingUrl }} originWhitelist={['*']} />
    </SafeAreaView>
  )
})

const styles = StyleSheet.create({
  headerBackButton: {
    width: 20,
    height: 20,
    tintColor: '#121212',
    opacity: 0.8,
    zIndex: 10
  },
  headerBackButtonContainer: {
    position: 'absolute',
    zIndex: 1,
    left: 10,
    padding: 5
  },
  webview: {
    flex: 1
  },
  stripeAccountButton: {
    color: DS.palette['Global/White'],
    marginTop: 0
  }
})
